// extracted by mini-css-extract-plugin
export default {"header":"PopOver_header__G93I2","close":"PopOver_close__HepsX"};